import { setVehicleParts } from '../setVehicleParts'
import { setLoading } from '../setLoading'
import { setPagination } from '../setPagination'
import { setError } from '../setError'
import { setTextSearchMessage } from '../setTextSearchMessage'
import { VehiclPartsListApi } from '../../api'

export const fetchVehicleParts = (fields) => async (dispatch, getState) => {
  try {
    const { limit, page } = fields

    dispatch(setError(''))
    dispatch(setLoading(true))

    const api = new VehiclPartsListApi()
    const { products, total_count, total_pages, current_page, seo, message, error } = await api.getProducts(fields)

    if (Array.isArray(products)) {
      dispatch(setVehicleParts(products))
      dispatch(setPagination({
        page: Number(current_page),
        totalCount: Number(total_count),
        totalPages: Number(total_pages)
      }))
    } else {
      dispatch(setVehicleParts([]))
      dispatch(setPagination({ page: 1, totalCount: 0, totalPages: 0 }))
    }

    if (error) dispatch(setError(error?.message || ''))

    if (message) dispatch(setTextSearchMessage(message))
    else dispatch(setTextSearchMessage(''))

    dispatch(setLoading(false))
  } catch (e) {
    console.log('fetchVehicleParts error', e)
    dispatch(setError(error?.message || ''))
    dispatch(setVehicleParts([]))
    dispatch(setPagination({ page: 1, totalCount: 0, totalPages: 0 }))
    dispatch(setLoading(false))
  }
}
